<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.33048 3.33203H11.6721C14.8226 3.33203 16.3979 3.33203 17.3766 4.30834C18.0506 4.98056 18.2605 5.93486 18.3258 7.48992C18.3388 7.79831 18.3453 7.95251 18.2877 8.05539C18.2301 8.15826 18.0002 8.28665 17.5404 8.54345C17.0297 8.82861 16.6845 9.37345 16.6845 9.9987C16.6845 10.6239 17.0297 11.1688 17.5404 11.4539C18.0002 11.7108 18.2301 11.8391 18.2877 11.942C18.3453 12.0449 18.3388 12.1991 18.3258 12.5074C18.2605 14.0625 18.0506 15.0169 17.3766 15.689C16.3979 16.6654 14.8226 16.6654 11.6721 16.6654H8.33048C5.17995 16.6654 3.60469 16.6654 2.62595 15.689C1.95206 15.0169 1.74216 14.0625 1.67678 12.5074C1.66382 12.1991 1.65733 12.0449 1.71492 11.942C1.77251 11.8391 2.00241 11.7108 2.4622 11.4539C2.97285 11.1688 3.31803 10.6239 3.31803 9.9987C3.31803 9.37345 2.97285 8.82861 2.4622 8.54345C2.00241 8.28665 1.77251 8.15826 1.71492 8.05538C1.65733 7.95251 1.66382 7.79831 1.67678 7.48992C1.74216 5.93486 1.95206 4.98056 2.62595 4.30834C3.60469 3.33203 5.17996 3.33203 8.33048 3.33203ZM12.9578 7.05676C13.2026 7.30083 13.2026 7.69656 12.9578 7.94064L7.94538 12.9406C7.70069 13.1847 7.30398 13.1847 7.05929 12.9406C6.8146 12.6965 6.8146 12.3009 7.05929 12.0568L12.0717 7.05676C12.3165 6.81268 12.7131 6.81268 12.9578 7.05676ZM12.0971 12.9154C12.5585 12.9154 12.9325 12.5423 12.9325 12.082C12.9325 11.6218 12.5585 11.2487 12.0971 11.2487C11.6357 11.2487 11.2616 11.6218 11.2616 12.082C11.2616 12.5423 11.6357 12.9154 12.0971 12.9154ZM7.92003 8.7487C8.38138 8.7487 8.75547 8.37561 8.75547 7.91536C8.75547 7.45513 8.38138 7.08203 7.92003 7.08203C7.45865 7.08203 7.08463 7.45513 7.08463 7.91536C7.08463 8.37561 7.45865 8.7487 7.92003 8.7487Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'RmuRevenueIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>